import { InvoiceLineType } from '../../enums/invoiceLineType'
import { InvoiceFormDepositLine } from '../../types/invoiceForm/invoiceFormLine/invoiceFormDepositLine'
import { InvoiceFormLine } from '../../types/invoiceForm/invoiceFormLine/invoiceFormLine'

export const isInvoiceFormDepositLine = (line: InvoiceFormLine): line is InvoiceFormDepositLine =>
  line.type === InvoiceLineType.Deposit
